// extracted by mini-css-extract-plugin
module.exports = {"parent":"DefaultLayout-module--parent--1Z67w","header_parent":"DefaultLayout-module--header_parent--xYMqS","main":"DefaultLayout-module--main--35x3i"};